// 0  - Укажите паспортные данные
// 1  - Дополнительные вопросы
// 4  - Подтверждение данных
// 2  - Укажите адрес регистрации и фактического проживания
// 3  - Данные о работе
// 5  - Выберите способ получения денег
// 6  - Загрузите фото паспорта
// 10 - Укажите ИНН
// 7  - Подпишите договор и заявление
// 9  - Сканы после подписания (только повторник)
// 8  - Таймер

export const stepUrlsFirst = {
  0: "/new_application-passport",
  1: "/new_application-additional-questions",
  4: "/new_application-number-confirmation", // мы должны сделать уприд как можно раньше (позиция по порядку шагов в анкете, не соотвествует номеру)
  2: "/new_application-address",
  3: "/new_application-place-work",
  5: "/new_application-select-map",
  6: "/new_application-docs-uploading",
  10: "/new_application-inn",
  7: "/new_application-signing",
  9: "/new_application-docs-uploading-signed",
  8: "/new_application-timer",
};

export const stepUrlsSecond = {
  0: "/reapplication-confirmation",
  1: "/new_application-additional-questions",
  2: "/reapplication-confirmation",
  3: "/reapplication-confirmation",
  4: "/reapplication-number-confirmation",
  5: "/reapplication-method-obtaining",
  6: "/reapplication-docs-uploading",
  10: "/new_application-inn",
  7: "/reapplication-signing",
  9: "/reapplication-docs-uploading-signed",
  8: "/new_application-timer",
};

export const getStepUrl = (step, isFirstApplication = true) => {
  let state;
  if (step === 1) {
    state = {
      backTo: isFirstApplication
        ? "/new_application-passport"
        : "/reapplication-confirmation",
    };
  }

  if (isFirstApplication) {
    return [stepUrlsFirst[step], state];
  }

  return [stepUrlsSecond[step], state];
};

export const getStepIndex = (pathname) => {
  const index = Object.keys(stepUrlsFirst).find(
    (key) => stepUrlsFirst[key] === pathname
  );
  if (index) return index;

  const res = Object.keys(stepUrlsSecond).find(
    (key) => stepUrlsSecond[key] === pathname
  );

  return res ? Number(res) : null;
};
